import BigNumber from 'bignumber.js';
import { SeriesType } from './const';
import { getTextWidth, numberFormat } from 'wetrade-tools';
// 柱状图、折线图tooltip浮层处理
export function combineTooltipFormatter(ev) {
    const { params, props } = ev;
    let headerText = ''; // tooltip的顶部显示
    let astr = '';
    const spanList = [];
    if (props.showTipHeaderText)
        headerText = params[0].name;
    params.map((item, index) => {
        let unit = props.unit || '';
        // isNullShow：为null的数据是否绘制为0；为true时，需要找到value的原始值
        const original = props.chartData.data[index][params[index].dataIndex];
        let value = props.isNullShow
            ? original?.value || (typeof original === 'number' ? original : item.value) || item.value
            : item.value;
        // 是否显示小数位
        const pointerNum = props.pointerNum.length > 0 && typeof props.pointerNum !== 'number'
            ? props.pointerNum[params[index].componentIndex]
            : props.pointerNum;
        // 是否显示千位符
        const sign = props.thousandthSign.length > 0 && typeof props.thousandthSign !== 'string'
            ? props.thousandthSign[params[index].componentIndex]
            : props.thousandthSign;
        // 单位
        if (unit.length > 0 && typeof unit !== 'string') {
            unit = unit[params[index].componentIndex];
        }
        // 是否要转换为万、亿
        const isConversion = typeof props.isTooltipConversion === 'boolean'
            ? props.isTooltipConversion
            : props.isTooltipConversion[params[index].componentIndex];
        // 不显示默认数值，处理小数位、千位符、是否截断
        if (!props.showDefaultNum) {
            value =
                props.isNullShow && value === null
                    ? null
                    : numberFormat(item.value || (props.isNumberDefault ? 0 : item.value), {
                        decimal: pointerNum,
                        t: sign === 'on',
                        r: isConversion
                            ? BigNumber.ROUND_HALF_UP
                            : props.roundDown
                                ? BigNumber.ROUND_DOWN
                                : BigNumber.ROUND_HALF_UP,
                        os: isConversion,
                    });
        }
        // 设置了isNullShow为true，要把数据为null的值转换成'0.00', false 为 '--
        if (props.isNullShow)
            value = value === null ? '--' : value;
        // 获取label名字
        const getLabelName = () => {
            if (props.showTooltipCurName) {
                return props.chartData.x[item.dataIndex];
            }
            if (props.customLegend?.length) {
                return props.customLegend[index];
            }
            return item.seriesName;
        };
        const valueSpan = `${props.showStringValue
            ? item.data?.showValue
            : item.data?.isNegative
                ? numberFormat(item.data?.realValue === null ? 0 : item.data?.realValue, {
                    decimal: pointerNum,
                    t: sign,
                })
                : value}${value === '--' || (props.showStringValue && item.data?.showValue === '--') ? '' : unit}`; // 值显示
        let seriesName = getLabelName(); // lable名字处理
        const findIndexs = seriesName.indexOf('[');
        if (findIndexs > -1 && props.isLabelRemoveId) {
            seriesName = seriesName.substring(0, findIndexs);
        }
        spanList.push(seriesName + '：' + value + unit);
        const isLine = (typeof props.scene === 'string' ? props.scene : props.scene[index]) === SeriesType.LINE; // 是否是折线图
        const width = `width:${isLine ? '10px' : '8px'}; margin: ${isLine ? '0 9px 0 -1px' : '1px 10px 0 0'};`;
        const height = `height:${isLine ? '3px' : '8px'};`;
        const marker = `<span style="display:inline-block;background-color:${item.color};${width} ${height}"></span>`;
        const divDom = `<div style="display:flex;align-items:center; margin-top: 10px;height: 18px;line-height: 18px;font-weight:400;">${marker}${seriesName} ：<span style="font-family:custom-fonts">${valueSpan}</span> ${props.toolTipPatchFunc ? props.toolTipPatchFunc(item) || '' : ''}</div>`;
        astr += divDom;
    });
    // tooltip换列处理
    const bodyH = document.body.clientHeight * 0.7; // tooltip最高占屏幕的70%
    const columnNum = Math.ceil(((props.chartData.data.length + (props.showTipHeaderText ? 1 : 0)) * 28) / bodyH);
    const boxH = Math.ceil(props.chartData.data.length / columnNum) * 28; // 每列真实占高
    const oneColumnNum = Math.ceil(boxH / 28); // 每列条数
    let boxW = 16 + (columnNum - 1) * 16; // 基础宽度
    // 是否需要多列显示，只有一列，直接返回dom；多列，计算宽度、高度，每列数量尽量相等
    for (let i = 0, length = columnNum; i < length; i++) {
        let tooltipMaxW = 0;
        // 数组 每列的数据
        const list = spanList.slice(i * oneColumnNum, i === length - 1 ? spanList.length : (i + 1) * oneColumnNum);
        for (const item of list) {
            tooltipMaxW = Math.max(tooltipMaxW, getTextWidth({ text: item }) + 14); // 根据每列计算出最大宽度
        }
        boxW += tooltipMaxW;
    }
    if (props.bottomText !== '' && props.bottomValueList.length) {
        const curVal = props.bottomValueList[params[0].dataIndex];
        astr += `<div style="padding-left:18px; margin-top:10px; font-weight:400">${props.bottomText} ： <span>${numberFormat(curVal, {
            decimal: typeof props.pointerNum !== 'number'
                ? props.pointerNum[props.pointerNum?.length - 1]
                : props.pointerNum,
            t: true,
            r: props.roundDown ? BigNumber.ROUND_DOWN : BigNumber.ROUND_HALF_UP,
            os: typeof props.isTooltipConversion === 'boolean'
                ? props.isTooltipConversion
                : props.isTooltipConversion[props.isTooltipConversion?.length - 1],
        })}</span></div>`;
    }
    if (columnNum <= 1)
        return props.showTipHeaderText ? headerText + astr : astr;
    const finallyBox = '<div style="width: ' +
        boxW +
        'px;' +
        ' max-height: ' +
        boxH +
        'px;display: flex; flex-direction: column; flex-wrap:wrap; overflow: hidden;">' +
        astr +
        '</div>';
    return props.showTipHeaderText ? headerText + finallyBox : finallyBox;
}
